import { h } from 'preact';
import cached from 'utils/cached';
import { getGMaps } from 'utils/bolt/gmaps';

import s from 'components/bolt/showtimes/mapMarker.sss';

const createMapPin = () => {
	const xmlns = 'http://www.w3.org/2000/svg';
	const svgElem = document.createElementNS(xmlns, 'svg');
	const path = document.createElementNS(xmlns, 'path');

	svgElem.setAttributeNS(null, 'viewBox', '0 0 16 16');
	path.setAttributeNS(null, 'd', 'M8 1a6.09 6.09 0 0 0-4.243 1.697 5.654 5.654 0 0 0 0 8.193l.014.012v.015L8 15l4.191-4.047v-.015l.051-.048a5.652 5.652 0 0 0 0-8.193A6.087 6.087 0 0 0 8 1');
	svgElem.appendChild(path);

	return svgElem;
};

export const createClass = cached(async () => {
	let gmaps = await getGMaps();

	const Marker = function(options = {}) {
		let { position, activeLogoLink, inactiveLogoLink, onClick, isActive } = options;

		if (!position) {
			throw new Error('A Marker cannot be created without a position');
		}

		this.isActive = isActive;
		this.activeLogoLink = activeLogoLink;
		this.inactiveLogoLink = inactiveLogoLink;

		if (!(position instanceof gmaps.LatLng)) {
			position = new gmaps.LatLng(position.lat, position.lon);
		}
		this.position = position;
		this.container = document.createElement('div');
		this.container.classList.add(s.marker);

		if (options.class) {
			this.container.classList.add(options.class);
		}

		if (isActive) {
			this.container.classList.add(s.active);
		}

		this.pin = createMapPin();
		this.container.appendChild(this.pin);

		this.logo = document.createElement('img');
		this.logo.src = isActive ? activeLogoLink : inactiveLogoLink;
		this.container.appendChild(this.logo);

		this.container.onclick = () => onClick(this);

		// Stop clicks, etc., from bubbling up to the map
		gmaps.OverlayView.preventMapHitsFrom(this.container);
		// gmaps.OverlayView.preventMapHitsAndGesturesFrom(this.container);
	};
	Marker.prototype = Object.create(gmaps.OverlayView.prototype);
	Marker.prototype.onAdd = function() {
		this.getPanes().floatPane.appendChild(this.container);
	};
	Marker.prototype.onRemove = function() {
		if (this.container.parentElement) {
			this.container.parentElement.removeChild(this.container);
		}
	};

	Marker.prototype.makeInactive = function() {
		this.container.classList.remove(s.active);
		this.logo.src = this.inactiveLogoLink;
		this.isActive = false;
	};

	Marker.prototype.makeActive = function() {
		this.container.classList.add(s.active);
		this.logo.src = this.activeLogoLink;
		this.isActive = true;
	};

	Marker.prototype.draw = function() {
		let pos = this.getProjection().fromLatLngToDivPixel(this.position);

		// Hide the popup when it is far out of view.
		let display = Math.abs(pos.x) < 4000 && Math.abs(pos.y) < 4000 ? 'block' : 'none';

		if (display === 'block') {
			this.container.style.left = pos.x + 'px';
			this.container.style.top = (pos.y + 8) + 'px';
		}
		if (this.container.style.display !== display) {
			this.container.style.display = display;
		}
	};

	return Marker;
});

export const createMarker = async (options, map) => {
	let Marker = await createClass();
	let marker = new Marker(options);
	if (map) {
		marker.setMap(map);
	}
	return marker;
};
